import { useTranslation } from "react-i18next";
import { useJourneyStaticDetails } from "../../context";
import { SegmentCard } from "./components";
import StepButtons from "../../components/StepButtons/StepButtons";
import useStepFlow from "src/Modules/Flights/hooks/useStepFlow";

export default function Details() {
  const { t } = useTranslation();
  const { journeySearchData } = useJourneyStaticDetails();
  const { goToNextStep } = useStepFlow();

  return (
    <div className="flex flex-col gap-3 w-full">
      {journeySearchData.segments.map((segment, index) => (
        <div key={`segment-${index}`} className="bg-background-default p-5 flex flex-col rounded-sm shadow-sm">
          <SegmentCard segment={segment} segmentNumber={index} />
        </div>
      ))}
      <StepButtons
        nextLabel={t("Flights.details.steps.proceedToPassengers")}
        onNext={() => goToNextStep()}
      />
    </div>
  );
}